<template>
    <div>
        <div class="max-w-md mx-auto p-6 bg-white rounded-lg shadow-md">
            <!-- logo -->
            <AppLogoForAuth />
            <!-- title -->
            <h2 class="text-3xl font-bold text-cost-blue mb-8 text-center">Create Account</h2>

            <p v-if="message" class="success">{{ message }}</p>
            <p v-if="errorMessage" class="error">{{ errorMessage }}</p>

            <form class="space-y-6" @submit.prevent="handleSignUp">
                <div>
                    <label class="block text-gray-700 mb-2">Email</label>
                    <input type="email" class="w-full p-3 border rounded-lg" v-model="email" required>
                </div>
                <div>
                    <label class="block text-gray-700 mb-2">Password</label>
                    <input type="password" class="w-full p-3 border rounded-lg" v-model="password" required>
                </div>
                <button class="w-full bg-cost-red text-white py-3 rounded-lg hover:bg-red-600">
                    Sign Up
                </button>
            </form>
            <p>
                <span>Already have an account?</span>
                <NuxtLink to="/auth/login">Login here</NuxtLink>
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
definePageMeta({
    layout: 'auth',
    public: true,
    middleware: ['redirect-if-authenticated']
})

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { signUp } from '~/composables/useAuth'

const email = ref('')
const password = ref('')
const errorMessage = ref('')
const message = ref('')
const router = useRouter()

const handleSignUp = async () => {
    errorMessage.value = ''
    message.value = ''
    try {
        // Call signUp from useAuth.ts; role is optional (default is 'member')
        const response = await signUp(email.value, password.value)
        // Show confirmation message that instructs the user to check their email
        message.value = response.message
        // Optionally redirect to login after a short delay
        setTimeout(() => {
            router.push('/auth/login')
        }, 3000)
    } catch (error: any) {
        // Display error message if sign up fails
        errorMessage.value = error.message || 'Sign up failed. Please try again.'
    }
}
</script>

<style scoped>
.auth-page {
    max-width: 400px;
    margin: auto;
    padding: 1rem;
}

.error {
    color: red;
}

.success {
    color: green;
}
</style>